<template>
<div class="chapter">
<div class="inner_page">
<div class="figure">
<img alt="Double Espresso: A Loretta Kovacs Novel (Book 2)" src="images/cover_11323.png"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?e68df86c